export const SAVE_WALLET = 'SAVE_WALLET'
export const SAVE_BALANCE = 'SAVE_BALANCE'
